import dynamic from 'next/dynamic';
const Carousel = dynamic(import('react-owl-carousel'), { ssr: false });

const OwlCarousel = props => {
  return (
    typeof window !== 'undefined' && (
      <Carousel {...props}>{props.children}</Carousel>
    )
  );
};

export default OwlCarousel;
